module.exports = __webpack_public_path__ + "img/Slice99.8ab283ab.png";